<div class="modal fade" id="basketModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ "order_details" | transloco }}</h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div class="container">
          @if(order) {
          <div class="row">
            <div class="col-12 col-md-6">
              <div
                class="d-flex justify-content-between align-items-start align-items-md-center flex-column-reverse flex-md-row mb-3 gap-3"
              >
                <div>
                  <div class="fw-bold">{{ "order_number" | transloco }}</div>
                  <div class="h5 mb-0">#{{ order.uid }}</div>
                </div>
                <span class="fs-6 badge bg-{{ order.status }}">
                  {{ order.status | transloco }}
                </span>
              </div>

              <div class="d-flex flex-column flex-md-row mb-3">
                <div class="me-md-3">
                  <div class="fw-bold">{{ "order_date" | transloco }}</div>
                  <div>{{ order.createdAt | date : "HH:mm, dd-MM-yyyy" }}</div>
                </div>
                <div class="vr d-none d-md-block"></div>
                <div class="ms-md-3">
                  <div class="fw-bold">
                    {{ "order_start_date" | transloco }}
                  </div>
                  <div>{{ order.startDate | date : "dd-MM-YY" }}</div>
                </div>
              </div>

              <div class="mb-3">
                <div class="fw-bold">{{ "note" | transloco }}</div>
                <div>{{ order.note || "-" }}</div>
              </div>
            </div>

            <div class="col-12 col-md-6"></div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
